import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import { household } from './modules/household/index';
import { loader } from './modules/loader';
import { auth } from './modules/auth';
import { individuals } from './modules/individuals';
import { incomeStreams } from './modules/income-streams';
import { otherIncomes } from './modules/other-incomes';
import { incomeNeeds } from './modules/income-needs';
import { accounts } from './modules/accounts';
import { company } from './modules/company';
import { constants } from './modules/constants';
import { beneficiaries } from './modules/beneficiaries';
import { settings } from './modules/settings';
import { advisor } from './modules/advisor';
import { netWorthSummary } from './modules/net-worth-summary';
import { incomePlanner } from './modules/income-planner';
import { draggableNavigation } from "./modules/draggable-navigation";
import { marketIndexes } from "./modules/market-indexes";
import formError from "./modules/form-errors"
import aqumulate from "./modules/aqumulate";
import lifeInsurance from "./modules/life-insurance";
import asset from "./modules/asset";
import property from "./modules/property";
import liability from "./modules/liability";
import ormPlugin from "@/store/models";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        household,
        loader,
        auth,
        individuals,
        incomeStreams,
        otherIncomes,
        incomeNeeds,
        accounts,
        company,
        constants,
        beneficiaries,
        settings,
        advisor,
        netWorthSummary,
        incomePlanner,
        draggableNavigation,
        marketIndexes,
        lifeInsurance,
        asset,
        aqumulate,
        formError,
        property,
        liability
    },
    plugins: [createPersistedState({
        paths: ['auth', 'individuals', 'company', 'constants', 'beneficiaries', 'settings', 'advisor'],
    }), ormPlugin],
})
